<ag-shr-color-sketch-popover [value]="value" (valueChange)="handleValueChange($event)" [presetColors]="presetColors">
  <dx-text-box
    #colorBoxRef
    class="color-sketch-input__input color-sketch-input__square-container"
    [style.--value-color]="value"
    [class.color-sketch-input__square-container--transparent]="value === 'transparent'"
    [class.color-sketch-input__square-container--inherit]="value === 'inherit'"
    [label]="label"
    [value]="value | colorSketchInputVarName: presetColors"
    [showClearButton]="true"
    [stylingMode]="'outlined'"
    [readOnly]="readOnly"
  >
    <dxi-button
      name="color"
      location="before"
      [options]="{
        icon: 'square',
        stylingMode: 'text',
        elementAttr: {
          style: 'color:' + value,
        },
      }"
    ></dxi-button>
    <!-- <dxi-button name="color" location="after" [options]="colorButtonOptions"></dxi-button> -->
  </dx-text-box>
</ag-shr-color-sketch-popover>
